/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import GroupMemberList from './GroupMemberList';
import SimpleGroupMemberList from './SimpleGroupMemberList';
import GroupMemberCounter from './GroupMemberCounter';
import SimpleGroupMemberCounter from './SimpleGroupMemberCounter';
import GroupMemberCounterRuby from './GroupMemberCounterRuby';
import { RUBY_GUEST_TYPES } from '../../constants';
import { PERMIT, ISSUANCE } from '../../props/permit';
import { shouldRenderGroupMemberList, hasRule } from '../../utils/utilsNew';

export default class GroupMemberDetail extends React.Component {
    static propTypes = {
        groupMembers: PropTypes.arrayOf(PropTypes.shape({})),
        minMemberQuota: PropTypes.number,
        maxMemberQuota: PropTypes.number,
        maxPetQuota: PropTypes.number,
        launchDetail: PropTypes.shape({
            entryDate: PropTypes.object,
            exitDate: PropTypes.object,
        }),
        handleGroupMemberChange: PropTypes.func,
        validation: PropTypes.shape({}),
        isDisabled: PropTypes.bool,
        excludeHolderFromList: PropTypes.bool,
        divisionId: PropTypes.string,
        permit: PERMIT,
        passOptions: PropTypes.shape({}),
        disableGroupSizeChanges: PropTypes.bool,
        disableGroupList: PropTypes.bool,
        hasSecureQuotaText: PropTypes.bool,
        isQuotaModifyAllowed: PropTypes.bool,
        issuance: ISSUANCE,
        onModifyDetails: PropTypes.func,
        isFieldSales: PropTypes.bool,
        validationRules: PropTypes.shape({}),
        refreshValidations: PropTypes.func,
        maxGroupSize: PropTypes.number,
        maxGroupSizeCommercial: PropTypes.number,
        isCommercialAccount: PropTypes.bool,
        isBypassQuotaCheck: PropTypes.bool,
        isBypassRulesValidations: PropTypes.bool,
        isHighUseFeeApplicable: PropTypes.bool,
        readOnly: PropTypes.bool,
        modifyDetailsButtonText: PropTypes.string,
    };

    static defaultProps = {
        isDisabled: false,
        readOnly: false,
        validationRules: {},
    };

    render() {
        if (get(this.props, 'permit.components.member_counter_ruby')) {
            return (
                <GroupMemberCounterRuby
                    isBypassQuotaCheck={this.props.isBypassQuotaCheck}
                    guestTypes={RUBY_GUEST_TYPES}
                    groupMembers={this.props.groupMembers}
                    maxPetQuota={this.props.maxPetQuota}
                    entryDate={this.props.launchDetail.entryDate}
                    memberLengthDisabled={this.props.disableGroupList}
                    onChange={this.props.handleGroupMemberChange}
                    permitId={this.props.permit.id}
                    issuance={this.props.issuance}
                    validation={this.props.validation}
                    isQuotaModifyAllowed={this.props.isQuotaModifyAllowed}
                    onModifyDetails={this.props.onModifyDetails}
                    modifyDetailsButtonText={this.props.modifyDetailsButtonText}
                    isFieldSales={this.props.isFieldSales}
                />
            );
        }
        if (get(this.props, 'permit.components.member_counter')) {
            return (
                <GroupMemberCounter
                    groupMembers={this.props.groupMembers}
                    minMemberQuota={this.props.minMemberQuota}
                    maxMemberQuota={this.props.maxMemberQuota}
                    entryDate={this.props.launchDetail.entryDate}
                    memberLengthDisabled={this.props.disableGroupList}
                    onChange={this.props.handleGroupMemberChange}
                    permit={this.props.permit}
                    issuance={this.props.issuance}
                    validation={this.props.validation}
                    isBypassRulesValidations={this.props.isBypassRulesValidations}
                    isQuotaModifyAllowed={this.props.isQuotaModifyAllowed}
                    onModifyDetails={this.props.onModifyDetails}
                    modifyDetailsButtonText={this.props.modifyDetailsButtonText}
                    isFieldSales={this.props.isFieldSales}
                />
            );
        }

        if (
            get(this.props, 'permit.components.simple_group_list') &&
            hasRule(
                'ShowMemberTypeCounter',
                this.props.permit.rules,
                get(this.props.issuance, 'division_id', '')
            )
        ) {
            return (
                <SimpleGroupMemberCounter
                    groupMembers={this.props.groupMembers}
                    minMemberQuota={this.props.minMemberQuota}
                    maxMemberQuota={this.props.maxMemberQuota}
                    entryDate={this.props.launchDetail.entryDate}
                    memberLengthDisabled={this.props.disableGroupList}
                    onChange={this.props.handleGroupMemberChange}
                    permit={this.props.permit}
                    issuance={this.props.issuance}
                    validation={this.props.validation}
                    isQuotaModifyAllowed={this.props.isQuotaModifyAllowed}
                    onModifyDetails={this.props.onModifyDetails}
                    modifyDetailsButtonText={this.props.modifyDetailsButtonText}
                    isFieldSales={this.props.isFieldSales}
                    disableGroupSizeChanges={this.props.disableGroupSizeChanges}
                    hasSecureQuotaText={this.props.hasSecureQuotaText}
                />
            );
        }

        if (get(this.props, 'permit.components.simple_group_list')) {
            return (
                <SimpleGroupMemberList
                    permit={this.props.permit}
                    minMemberQuota={this.props.minMemberQuota}
                    maxMemberQuota={this.props.maxMemberQuota}
                    isDisabled={this.props.disableGroupList}
                    groupMembers={this.props.groupMembers}
                    handleGroupMemberChange={this.props.handleGroupMemberChange}
                    entryDate={this.props.launchDetail.entryDate}
                    validation={this.props.validation}
                    hasSecureQuotaText={this.props.hasSecureQuotaText}
                    issuance={this.props.issuance}
                    isQuotaModifyAllowed={this.props.isQuotaModifyAllowed}
                    onModifyDetails={this.props.onModifyDetails}
                    modifyDetailsButtonText={this.props.modifyDetailsButtonText}
                    isFieldSales={this.props.isFieldSales}
                />
            );
        }

        if (!shouldRenderGroupMemberList(this.props.permit)) {
            return null;
        }

        return (
            <GroupMemberList
                permit={this.props.permit}
                divisionId={this.props.divisionId}
                minMemberQuota={this.props.minMemberQuota}
                maxMemberQuota={this.props.maxMemberQuota}
                entryDate={this.props.launchDetail.entryDate}
                exitDate={this.props.launchDetail.exitDate}
                groupMembers={this.props.groupMembers}
                handleGroupMemberChange={this.props.handleGroupMemberChange}
                validation={this.props.validation}
                isDisabled={this.props.isDisabled}
                readOnly={this.props.readOnly}
                isFirstGroupMemberDateDisabled={!this.props.isCommercialAccount}
                passOptions={this.props.passOptions}
                disableGroupSizeChanges={this.props.disableGroupSizeChanges}
                excludeHolderFromList={this.props.excludeHolderFromList}
                issuance={this.props.issuance}
                isQuotaModifyAllowed={this.props.isQuotaModifyAllowed}
                onModifyDetails={this.props.onModifyDetails}
                modifyDetailsButtonText={this.props.modifyDetailsButtonText}
                isFieldSales={this.props.isFieldSales}
                refreshValidations={this.props.refreshValidations}
                validationRules={this.props.validationRules}
                maxGroupSize={this.props.maxGroupSize}
                maxGroupSizeCommercial={this.props.maxGroupSizeCommercial}
                isHighUseFeeApplicable={this.props.isHighUseFeeApplicable}
            />
        );
    }
}
